import { createSvgIcon } from '@mui/material/utils';

const GratiIcon = createSvgIcon(
  <image href="/icon.svg" x="0" y="0" width="24" height="24" />,
  'Grati'
);

export default GratiIcon;